import { Component, Input, inject } from "@angular/core";
import { AuditWorkflowDataService } from "@app/audit/services/audit-workflow-data.service";
import { AuditModel } from "@app/audit/shared/data-models/audit-model";
import { AuditWorkflowHistoryModel } from "@app/audit/shared/data-models/audit-workflow-history-model";
import { GenericListConfig } from "@app/shared/models/GenericList/GenericList";
import { GenericListFieldType } from "@app/shared/models/GenericList/GenericListField";
import { nameof } from "@methods/jeffs-toolkit";
import { firstValueFrom } from "rxjs";
import { injectTranslation } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/audit/i18n/scope";
import { GenericListManagerComponent } from "@app/shared/generic-managers/generic-list-manager/generic-list-manager.component";

@Component({
    selector: "audit-detail-workflow-history",
    templateUrl: "./audit-detail-workflow-history.component.html",
    imports: [GenericListManagerComponent],
})
export class AuditDetailWorkflowHistoryComponent {
    private _ds = inject(AuditWorkflowDataService);
    private _translation = injectTranslation(scope);

    @Input() auditModel: AuditModel;

    public config: GenericListConfig;

    async load() {
        if (this.config) {
            return;
        }

        const workflowHistory = await firstValueFrom(this._ds.getWorkflowHistory(this.auditModel.guid));
        await this._translation.ready();
        this.setupHistoryListConfig(workflowHistory);
    }

    private setupHistoryListConfig(workflowHistory: AuditWorkflowHistoryModel[]) {
        this.config = <GenericListConfig>{
            idProp: nameof<AuditWorkflowHistoryModel>((x) => x.id),
            name: this._translation.t("workflowHistory.title"),
            data: workflowHistory,

            allowAdd: false,
            allowEdit: false,
            allowDelete: false,

            fields: [
                {
                    fieldName: nameof<AuditWorkflowHistoryModel>((x) => x.statusDescription),
                    prettyName: this._translation.t("workflowHistory.statusColumn"),
                    fieldType: GenericListFieldType.Text,
                },
                {
                    fieldName: nameof<AuditWorkflowHistoryModel>((x) => x.actionDescription),
                    prettyName: this._translation.t("workflowHistory.actionColumn"),
                    fieldType: GenericListFieldType.Text,
                },
                {
                    fieldName: nameof<AuditWorkflowHistoryModel>((x) => x.actionDate),
                    prettyName: this._translation.t("workflowHistory.onColumn"),
                    fieldType: GenericListFieldType.DateTime,
                },
                {
                    fieldName: nameof<AuditWorkflowHistoryModel>((x) => x.actionBy),
                    prettyName: this._translation.t("workflowHistory.byColumn"),
                    fieldType: GenericListFieldType.Text,
                },
                {
                    fieldName: nameof<AuditWorkflowHistoryModel>((x) => x.comment),
                    prettyName: this._translation.t("workflowHistory.commentColumn"),
                    fieldType: GenericListFieldType.TextArea,
                },
            ],

            uiid: "list-workflow-history",
        };
    }
}
